import { render, staticRenderFns } from "./LoginRegisterBox.vue?vue&type=template&id=675810c4&scoped=true&"
import script from "./LoginRegisterBox.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterBox.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterBox.vue?vue&type=style&index=0&id=675810c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675810c4",
  null
  
)

export default component.exports